import gql from 'graphql-tag'

export const GET_S3_URL = gql`
  mutation GET_S3_URL(
    $filename: String!
    $filetype: String!
    $bucket: String!
  ) {
    getS3URL(filename: $filename, filetype: $filetype, bucket: $bucket) {
      url
    }
  }
`

export default {
  GET_S3_URL,
}
